var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "confirmInfo" }, [
    _c("div", { staticClass: "info" }, [
      _c("ul", { staticClass: "info-box" }, [
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("姓名：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.title))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("性别：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.sex_title))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("生日：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.birthday))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("身份证号：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.identity))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("学号：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.student_code))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("民族：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.nation))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("专业：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.profession_title))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("层次：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.level_title))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("学制：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.level_year))),
          ]),
        ]),
        _c("li", { staticClass: "info-item" }, [
          _c("div", { staticClass: "title" }, [_vm._v("学习形式：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("isEmpty")(_vm.userInfo.shape_title))),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "btn-box" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmClick } },
            [_vm._v("确认信息")]
          ),
          _c(
            "el-button",
            {
              staticClass: "exit-btn",
              attrs: { type: "primary" },
              on: { click: _vm.exit },
            },
            [_vm._v("退出登录")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }